import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import ListItemSelector from "../common/ListItemSelector";
import LocalizedMessage from '../common/LocalizedMessage';

function ClassStudentPickerModal({ show, options, isSubmitting, error, onSelect, onHide, serverSearch, query, onQueryChange, onLoadMore }) {
  const { t: tr } = useTranslation();
  const [viewportHeight, setViewportHeight] = useState(null);
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!show || !viewport) return undefined;
    const updateHeight = () => setViewportHeight(viewport.height);
    updateHeight();
    viewport.addEventListener("resize", updateHeight);
    return () => viewport.removeEventListener("resize", updateHeight);
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={() => { if (!isSubmitting) onHide(); }}
      keyboard={!isSubmitting}
      backdrop={isSubmitting ? "static" : true}
      centered
      dialogClassName="selector-modal class-student-picker-modal"
      aria-labelledby="class-student-picker-title"
      onEntered={node => {
        // This Bootstrap/overlays version hides its own dialog and puts the label on the inner document.
        node.removeAttribute("aria-hidden");
        node.setAttribute("aria-labelledby", "class-student-picker-title");
      }}
      style={viewportHeight ? { "--student-picker-height": `${viewportHeight * 0.8}px` } : undefined}
    >
      <Modal.Header>
        <Modal.Title id="class-student-picker-title">{tr("manage:addAStudentToTheLesson_91")}</Modal.Title>
        <button type="button" className="close" aria-label={tr("common:close")} disabled={isSubmitting} onClick={onHide}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>{tr("manage:selectAStudentToAddThemToTheLesson_92")}</p>
        {error && <div role="alert" className="alert alert-danger"><LocalizedMessage isError value={error} /></div>}
        {isSubmitting && <p role="status">{tr("manage:addingStudent_93")}</p>}
        {serverSearch && (
        <label className="d-block" htmlFor="teacher-candidate-search">{tr('manage:teacherExtensions.search')}
          <input id="teacher-candidate-search" className="form-control" value={query} onChange={event => onQueryChange(event.target.value)} disabled={isSubmitting} />
        </label>
        )}
        {serverSearch && onLoadMore && (
        <button type="button" className="btn manage-teal-button" disabled={isSubmitting} onClick={onLoadMore}>
          {tr('manage:teacherExtensions.more')}
        </button>
        )}
        {show && (
          <ListItemSelector
            label=""
            hideSearch={serverSearch}
            options={options}
            onSelect={onSelect}
            disabled={isSubmitting}
            searchLabel="Szukaj ucznia lub klienta"
            keyboardButtonText={tr("manage:hideKeyboard_95")}
            emptyMessage={tr("manage:noStudentsToAdd_96")}
            noResultsMessage={tr("manage:noStudentsMatchYourSearch_97")}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

ClassStudentPickerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  options: PropTypes.array.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  serverSearch: PropTypes.bool,
  query: PropTypes.string,
  onQueryChange: PropTypes.func,
  onLoadMore: PropTypes.func,
};

ClassStudentPickerModal.defaultProps = { serverSearch: false, query: '', onQueryChange: () => {}, onLoadMore: null };

export default ClassStudentPickerModal;
